import { render, staticRenderFns } from "./searchRecords.html?vue&type=template&id=a09f2c22&scoped=true&external"
import script from "./searchRecords.js?vue&type=script&lang=js&external"
export * from "./searchRecords.js?vue&type=script&lang=js&external"
import style0 from "./searchRecords.scss?vue&type=style&index=0&id=a09f2c22&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09f2c22",
  null
  
)

export default component.exports